import { ModuleTokens } from './tickets-base.constant';
import { TicketStatuses } from '@app/common/tickets';

export type TicketState
  = 'CLOSED'
  | 'PLANNED'
  | 'RESOLVED'
  | 'ACCEPTED'
  | 'IN_REALISATION'
  | 'WAITING_FOR_CLIENT'
  | 'WAITING_AUTHORIZATION';

export class TicketsBaseState {
  entities: TicketsBaseEntityEntities;
  ticketTopics: TicketTopicEntity[];
  list: string[];

  constructor() {
    this.entities = {
      [ModuleTokens.Name]: { },
      [ModuleTokens.Messages]: { }
    };
    this.ticketTopics = [];
    this.list = [];
  }
}

export interface TicketsBaseEntityEntities {
  [ModuleTokens.Name]: { [id: string]: TicketsEntityNormalized; };
  [ModuleTokens.Messages]: { [id: string]: TicketsEntityNormalized; };
}

export interface TicketsEntityNormalizedData {
  entities: TicketsBaseEntityEntities;
  result: string[];
}

export interface TicketMessageEntity {
  created: string;
  display: string;
  id: string;
  messageText: string;
  signature: string;
  attachments: TicketFile[];
  ticketId: string;
  extId: string;
  messageHiddenText: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  author: any;
}

export interface TicketsEntityLight {
  id: string;
  clientId: string;
  title: string;
  created: string;
  lastUpdate: string;
  copyList: string[];
  code: string;
  publicMessageCount: number;
  attachedPriceOffer: AttachedPriceOfferStates;
  clientZoneStatus: TicketStatuses;
  adminUserAssignLock: boolean;
  lastTicketMessageText?: string;
  lastTicketMessageId?: string;
  // TODO: entity
  lastTicketMessageAuthor?: {
    email: string;
    fullName: string;
    id: string;
  };
  realizationDateWaitingConfirmation: boolean;
  assignedUserEmail: string;
}

export enum AttachedPriceOfferStates {
  None = 'NONE',
  Unconfirmed = 'UNCONFIRMED',
  Confirmed = 'CONFIRMED'
}

export interface TicketsEntityBase extends TicketsEntityLight {

}

export interface TicketsEntityNormalized extends TicketsEntityBase {
  ticketMessageList: string[];
}

export interface TicketsEntity extends TicketsEntityBase {
  ticketMessageList: TicketMessageEntity[];
}

export interface TicketFile {
  contentType: string;
  created: string;
  id: string;
  name: string;
  sizeFormatted: string;
  sizeKilobytes: number;
  ticketMessageId: string;
}

export interface TicketTopicEntity {
  group: string;
  id: string;
  name: { [lang: string]: string; };
  order: number;
  supportDepartmentId: string;
  template: { [lang: string]: string; };
}

export interface TicketTopicGroup {
  key: string;
  items: TicketTopicEntity[];
}

export type TicketRating = 1 | 2 | 3 | 4;
